





















































































































import { computed, defineComponent, reactive, ref, PropType } from '@vue/composition-api';
import { bytesToSize, getFileNameAndExtension } from '@tt4b/ttam-utils';
import { FileUploadStatus, MaterialType, VideoToUpload } from '@tt4b/ttam-enums';
import { useMaterialNameValidate } from '@tt4b/ttam-hooks';

const name = 'ttam-file-select-table';

export default defineComponent({
  name,

  props: {
    files: { type: Array as PropType<VideoToUpload[]>, default: () => [] },
    fileType: { type: String as PropType<MaterialType>, default: MaterialType.Video },
    inventoryCheck: { type: Boolean, default: () => true },
  },

  setup(props, ctx) {
    /** 记录当前修改名字的项 */
    let fileToChangeName;

    const tableNode = ref();
    const selectedItems = ref([]);
    const nameToChanged = reactive({ name: '', extension: '' });
    const nameChangeError = ref('');
    const nameChanging = ref(false);

    const fileUploadStatus = computed(() => FileUploadStatus);

    /** 选中所有可选的视频 */
    function selectAll() {
      props.files.forEach(row => tableNode.value.toggleRowSelection(row, row.status === FileUploadStatus.Ready));
    }

    /** 选中事件 */
    function onSelectChange(val) {
      selectedItems.value = val;
      ctx.emit('onSelect', selectedItems.value);
    }

    /** 修改名字 */
    function changeName(material) {
      fileToChangeName = material;
      const { extension, excludeExtName } = getFileNameAndExtension(material.name);
      nameToChanged.name = excludeExtName;
      nameToChanged.extension = extension;
    }

    const getErrorMessageList = verify => {
      const result = [] as Array<any>;
      verify?.forEach(item => {
        item?.message?.forEach(messageItem => {
          result.push(`${item.label} : ${messageItem}`);
        });
      });

      return result ?? [];
    };

    /** 关闭修改 name 的 popover */
    function onCancelNameChange() {
      document.body.click();
    }

    /** 确认修改 name */
    function onConfirmNameChange(material) {
      nameChanging.value = true;
      const fullNameChanged = `${nameToChanged.name}${nameToChanged.extension}`;
      const otherNames = props.files.filter(file => file !== fileToChangeName).map(i => i.name);
      useMaterialNameValidate({
        targetName: fullNameChanged,
        type: props.fileType,
        otherNames,
      }).then(data => {
        const { type, msg } = data;
        nameChanging.value = false;
        if (msg) {
          return (nameChangeError.value = msg as string);
        }
        nameChangeError.value = '';
        material.name = `${nameToChanged.name}${nameToChanged.extension}`;
        material.raw = new window.File([material.raw], material.name, { type: material.raw.type });
        onCancelNameChange();
        if (material.status === FileUploadStatus.NameDuplicate) {
          material.status = FileUploadStatus.Ready;
          material.disabled = false;
          // 修改名称后，将可选中的上传文件，自动选中
          selectAll();
        }
      });
    }

    function backCrop() {
      ctx.emit('backCrop');
    }

    function formatSize(item) {
      return bytesToSize(item.size ?? 0);
    }

    return {
      name,
      tableNode,
      nameToChanged,
      nameChangeError,
      nameChanging,
      selectedItems,
      fileUploadStatus,

      selectAll,
      formatSize,
      changeName,
      getErrorMessageList,
      onCancelNameChange,
      onConfirmNameChange,
      onSelectChange,
      backCrop,
    };
  },
});
